import { render, staticRenderFns } from "./ListProductions.vue?vue&type=template&id=41faef27&scoped=true&"
import script from "./ListProductions.vue?vue&type=script&lang=js&"
export * from "./ListProductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41faef27",
  null
  
)

export default component.exports